import * as React from 'react';
import cn from 'clsx';

import * as styles from './styles.css';

import { ArticleParagraph2, Button, UIHeading3, useDeviceType } from '@cian/ui-kit';

export interface IErrorBlockProps {
  title: string;
  text: string;
  buttonText: string;
  isFullSize?: boolean;
  onClick: () => void;
}
export const ErrorBlock = (props: IErrorBlockProps) => {
  const { title, text, buttonText, isFullSize = false, onClick } = props;
  const isHandheld = useDeviceType() !== 'desktop';

  return (
    <div className={cn(styles['error-block'], isFullSize && styles['full-size'])}>
      <div className={styles['sign']} />
      <div className={styles['title']}>
        <UIHeading3>{title}</UIHeading3>
      </div>
      <ArticleParagraph2>{text}</ArticleParagraph2>
      <div className={styles['button']}>
        <Button size={isHandheld ? 'M' : 'XS'} onClick={onClick}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

ErrorBlock.displayName = 'ErrorBlock';
